export function getSeHsCodeMode(value) {
  const mode = Number(value)
  return Number.isNaN(mode) ? 0 : mode
}

export function isSeparateHsCodeMode(lob, seHsCodeMode) {
  return lob === 'SE' && getSeHsCodeMode(seHsCodeMode) > 0
}

export function shouldSyncDocHsCodeFromJob({ seHsCodeMode, currentDocHsCode }) {
  const mode = getSeHsCodeMode(seHsCodeMode)
  if (mode === 0) {
    return true
  }
  if (mode === 1) {
    return currentDocHsCode === null || currentDocHsCode === undefined || String(currentDocHsCode).trim() === ''
  }
  return false
}

export function getInitialDocHsCode({ jobHsCode, seHsCodeMode }) {
  return getSeHsCodeMode(seHsCodeMode) === 2 ? '' : (jobHsCode || '')
}
